import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HomeRoutingModule } from "./home-routing.module";
import { HomeComponent } from "./home.component";
import { SlideshowModule } from "ng-simple-slideshow";
import { BannerComponent } from "./banner/banner.component";
import { ScrollToModule } from "@nicky-lenaers/ngx-scroll-to";
import { ScrollToTopComponent } from "./scroll-to-top/scroll-to-top.component";
import { DeferLoadModule } from "@trademe/ng-defer-load";
import { LoaderModule } from "../../modules/loader-module/loader-module";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [HomeComponent, BannerComponent, ScrollToTopComponent],
  imports: [
    CommonModule,
    SlideshowModule,
    HomeRoutingModule,
    DeferLoadModule,
    LoaderModule,
    TranslateModule.forChild(),
    ScrollToModule.forRoot()
  ]
})
export class HomeModule {}
